
/* Single image */
import img1 from '../images/products/A.jpg'
import img2 from '../images/products/B.jpg'
import img3 from '../images/products/C.png'
import img4 from '../images/products/D.png'
import img5 from '../images/products/E.png'
import img6 from '../images/products/F.png'
import img7 from '../images/products/G.png'
import img8 from '../images/products/H.png'
import img9 from '../images/products/I.png'
import img10 from '../images/products/J.png'




import Simg1 from '../images/service-single/img-1.jpg'
import Simg2 from '../images/service-single/img-2.jpg'
import Simg3 from '../images/service-single/img-3.jpg'
import Simg4 from '../images/service-single/img-4.jpg'
import Simg5 from '../images/service-single/img-5.jpg'
import Simg6 from '../images/service-single/img-6.jpg'
import Simg7 from '../images/service-single/img-7.jpg'
import Simg8 from '../images/service-single/img-8.jpg'
import Simg9 from '../images/service-single/img-9.jpg'
import Simg10 from '../images/service-single/img-10.jpg'
const Services = [
    {
        id: 1,
        image: img1,
        simag: Simg1,
        subtitle: '',
        title: 'PP Fabric',
        description: 'It was popularised with the release sheets containing passages and more recently with software.',
        slug: 'Air-Transport'
    },
    {
        id: 2,
        image: img2,
        simag: Simg2,
        subtitle: 'Transport',
        title: 'PP Woven Bag',
        description: 'It was popularised with the release sheets containing passages and more recently with software.',
        slug: 'Ocean-Transport'
    },
    {
        id: 3,
        image: img3,
        simag: Simg3,
        subtitle: 'Transport',
        title: 'BOPP Multicolor Bag',
        description: 'It was popularised with the release sheets containing passages and more recently with software.',
        slug: 'Road-Transport'
    },
    {
        id: 4,
        image: img4,
        simag: Simg4,
        subtitle: 'Transport',
        title: 'PP Laminated Kraft',
        description: 'It was popularised with the release sheets containing passages and more recently with software.',
        slug: 'Road-Transport2'
    },
    {
        id: 5,
        image: img5,
        simag: Simg5,
        subtitle: 'Transport',
        title: 'Leno Bag',
        description: 'It was popularised with the release sheets containing passages and more recently with software.',
        slug: 'Ocean-Transport2'
    },
    {
        id: 6,
        image: img6,
        simag: Simg6,
        subtitle: 'Transport',
        title: 'Corrugated Box',
        description: 'It was popularised with the release sheets containing passages and more recently with software.',
        slug: 'Road-Transport3'
    },
    {
        id: 7,
        image: img7,
        simag: Simg7,
        subtitle: 'Transport',
        title: '6 Layer Loft Water Tank',
        description: 'It was popularised with the release sheets containing passages and more recently with software.',
        slug: 'Train-Transport3'
    },
    {
        id: 8,
        icon:'fi flaticon-air-freight',
        image: img8,
        simag: Simg8,
        subtitle: 'Transport',
        title: '3 Layer Water Tank',
        description: 'It was popularised with the release sheets containing passages and more recently with software.',
        slug: 'Train-Transport8'
    },
    {
        id: 9,
        icon:'fi flaticon-delivery-truck',
        image: img9,
        simag: Simg9,
        subtitle: 'Transport',
        title: '10 Layer Water Tank',
        description: 'It was popularised with the release sheets containing passages and more recently with software.',
        slug: 'Train-Transport9'
    },
    {
        id: 10,
        icon:'fi flaticon-cruise',
        image: img10,
        simag: Simg10,
        subtitle: 'Transport',
        title: '6 Layer Water Tank',
        description: 'It was popularised with the release sheets containing passages and more recently with software.',
        slug: 'Train-Transport10'
    },
];
export default Services;